<section class="container-fluid py-2rem">
    <router-outlet></router-outlet>
</section>